import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output
} from '@angular/core';
import { START_APPLICATION_BUTTON_CONSTANTS } from './start-application-button.constants';
import { ApplicationUtilityService } from '@edassist/common';
import { AuthenticationService, User } from '@edassist/api';
import { Subscription } from 'rxjs';

@Component({
	selector: 'tu-start-application-button',
	templateUrl: './start-application-button.component.html'
})
export class StartApplicationButtonComponent implements OnInit, OnDestroy {
	@Output() readonly startApplicationButtonClick = new EventEmitter<any>();
	@Input() buttonText = START_APPLICATION_BUTTON_CONSTANTS.DEFAULT_BUTTON_TEXT;
	@Input() ariaLabel;

	buttonDisabled = false;

	private readonly subscriptions = new Subscription();

	constructor(private readonly authService: AuthenticationService) {}

	ngOnInit(): void {
		this.subscriptions.add(
			this.authService.currentUser.subscribe((user: User) => {
				this.buttonDisabled =
					ApplicationUtilityService.disableCreateNewApplication(user);
			})
		);
	}

	handleNewApplicationButtonClick(): void {
		this.startApplicationButtonClick.emit();
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}
}
